import React, { useEffect, useState } from 'react';
import MyFamilyFirstBooking from '../../../../common/myFamilyFirstBookings';
import SearchBar from '../../../../common/commonSearchBar';
import { useSelector, useDispatch } from 'react-redux';
import MyFamilyFirstMoreInfoModal from '../../../gifts/myFamilyFirst/myFamilyFirstMoreInfoModal';
import Pagination from '../../../../common/pagination';
import * as HoneymoonAction from '../../../../actions/honeymoonAction'
import ConfirmModal from '../../../wedding/requests/confirmModal';
import ClosedModal from '../../closeRequestModal';
import { closeRequestInputVal } from '../../../../actions/holidayRequestAction';

const Planning = ({status}) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [moreInfoModalData, setMoreInfoModalData] = useState({});
    const [page, setPage] = useState(1);
    const[ confirmedRequestModalData,setConfirmedRequestModalData]=useState({})
    const [isconfirmAmountBool,setIsconfirmAmountBool]=useState(null)
    
    
    const [ id, setId ] = useState(null);
    const[statuschange,setStatuschange]=useState()

    const[requestModalConfirm,setRequestModalConfirm]=useState(false)
    const[confirmedRequestAmount,setConfirmedRequestAmount]=useState("")
    const [requestModal, setRequestModal] = useState(false);
    const [closeRequestModalData, setCloseRequestModalData] = useState({});
    const [isclosingMessageBool, setIsclosingMessageBool] = useState(null);
    const closeRequestMessage = useSelector(state => state.holidayRequest.closeRequestMsg);


    const honeymoonPlanningData = useSelector(state => state.honeymoon.honeymoonPlanning?.results);
    const totalPage = useSelector(state => state.honeymoon?.honeymoonPlanning?.total_pages);
    const START_DATE = useSelector(state => state.honeymoon.startDate);
    const END_DATE = useSelector(state => state.honeymoon.endDate);
    const SEARCH_TERM = useSelector(state => state.honeymoon.searchTerm);
    const PAGE_NO = useSelector(state => state.honeymoon.pageNo);

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => document.body.style.overflow = 'unset';
    }, [showModal]);
    useEffect(() => {
        setPage(1)
      }, [status])
    const handleMoreInfoClick = (data) => {
        setShowModal(true);
        setMoreInfoModalData(data);
    };

  
    const requestStatusChange = (event, id,data) => {
        setCloseRequestModalData(data)
        setId(id);
        setConfirmedRequestModalData(data)
          let status = event.target.value;
          setStatuschange(status)
    
          if(status === "confirmed")setRequestModalConfirm(true);
          else if(status === "cancelled")setRequestModal(true);
          else{
            dispatch(HoneymoonAction.honeymoonRequestStatusChange(status, id, null,refereshList))
  
          }
          
      };
  
      const confirmRequestHandler=()=>{
          
          
        setIsconfirmAmountBool(false)
       if(confirmedRequestAmount==="")setIsconfirmAmountBool(true)
        else {
        dispatch(HoneymoonAction.honeymoonRequestStatusChangeConfirm("confirmed", id,confirmedRequestAmount, refereshList))
          setRequestModalConfirm(false)
        }
        // dispatch(confirmRequestInputVal(''));
       
        
    
      }
  
  
      const notToConfirm=()=>{
     
        setRequestModalConfirm(false)
        setIsconfirmAmountBool(false);
      
      }
    const refereshList = () => {
        dispatch(HoneymoonAction.getHoneymoonRequested(1));
        dispatch(HoneymoonAction.getHoneymoonPlanning(page));
        dispatch(HoneymoonAction.getHoneymoonConfirmed(1));
        dispatch(HoneymoonAction.getHoneymoonCancelled(1));
    };

    const handlePagination = (e, value) => {
        setPage(value);
        dispatch(HoneymoonAction.setPageNo(value))
        if (SEARCH_TERM || START_DATE || END_DATE) {
            dispatch(HoneymoonAction.searchHoneymoonRequests(SEARCH_TERM, START_DATE, END_DATE, "planning", value));
        } else {
            dispatch(HoneymoonAction.getHoneymoonPlanning(value));
        }
    };

    const handleChange = (event) => {
        if (event.target.value) {
            dispatch(HoneymoonAction.searchHoneymoonRequests(event.target.value, START_DATE, END_DATE, "planning", PAGE_NO));
        } else {
            dispatch(HoneymoonAction.getHoneymoonPlanning(1));
            setPage(1);
        }
        dispatch(HoneymoonAction.setSearchTerm(event.target.value))
    };
    const closeRequestHandler = () => {
 
        setIsclosingMessageBool(false)
        if(closeRequestMessage === "")setIsclosingMessageBool(true)
        else {
            dispatch(HoneymoonAction.honeymoonRequestStatusChange(statuschange, id,closeRequestMessage, refereshList))
            setRequestModal(false)
          }
          dispatch(closeRequestInputVal(''));
        };
      
    
    const notToCancel=()=>{
        setRequestModal(false)
        setIsclosingMessageBool(false);
    
    }

    const honeymoonPlanning = honeymoonPlanningData && honeymoonPlanningData.map(data => (
        <MyFamilyFirstBooking
            locationsPreferred={data.locations_preferred}
            occasion={data.occasion}
            requestedBy={data.contact_name}
            email={data.contact_email}
            contactNum={data.contact_number}
            messageTitle={data.specific_request ? data.specific_request : 'No Message'}
            specialRequest={data.specific_request ? data.specific_request : "N/A"}
            onClick={() => handleMoreInfoClick(data)}
            myFamilyFirstStatusChange={requestStatusChange}
            data={data}
            id={data.id}
            refCode={data.ref_id ? `#${data.ref_id}` : "No ref id"}
            value={data.status}
        />
    ));

    return (
        <>
            <SearchBar
                searchVal={SEARCH_TERM}
                handleChange={handleChange}
            />
            {honeymoonPlanningData && honeymoonPlanningData?.length === 0 &&
                <div className="enquiry-card-holder">No Record Found!</div>
            }
            {honeymoonPlanning}
            <MyFamilyFirstMoreInfoModal
                open={showModal}
                close={() => setShowModal(false)}
                modalData={moreInfoModalData}
                section={"Honeymoon Requested"}
                isCancellationMessage={false}
            />
            <Pagination
                totalPage={totalPage}
                page={page} onChange={(event, value) => handlePagination(event, value)}
            />
        {requestModalConfirm &&
        <ConfirmModal
        open={requestModalConfirm}
        handleClose={notToConfirm}
        data={confirmedRequestModalData}
        isconfirmAmountBool={isconfirmAmountBool}
        setConfirmedRequestAmount={setConfirmedRequestAmount}
        confirmRequestHandler={confirmRequestHandler}
        />

      }
          {requestModal && 
                <ClosedModal 
                  open={requestModal}
                  handleClose={notToCancel}
                  data={closeRequestModalData}
                  isclosingMessage={isclosingMessageBool}
                  closeRequestHandler={closeRequestHandler}
                />
              }
        </>
    );
};

export default Planning;
